module.exports = {"Centrifugal":"Centrifugal","Diecasting":"Diecasting","Investment":"Investment","Permanent Mold":"Permanent Mold","Plaster":"Plaster","Sand":"Sand","Squeeze/Semi-Solid":"Squeeze/Semi-Solid","V-Process":"V-Process","Vacuum Melt Capabilities":"Vacuum Melt Capabilities","Investment Casting Tooling":"Investment Casting Tooling"}


//////////////////
// WEBPACK FOOTER
// ./src/config/castingProcess.json
// module id = 5253
// module chunks = 1